import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { PlayerListenerComponentDirective } from '../../../../base-component/player-listener.component'
import { ITrack } from '../../../../Interface/track'
import { PlayerLogic } from '../../../../player/AngPlayer'
import { CartService } from '../../../../services/cart.service'

@Component({
  selector: 'bmcore-track-box-cover',
  templateUrl: './bmcore-track-box-cover.component.html',
  styleUrls: ['./bmcore-track-box-cover.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackBoxCoverComponent extends PlayerListenerComponentDirective<ITrack> implements OnInit {
  @Input() track: ITrack
  @Input() tracks: ITrack[] // needed to set up a playlist

  constructor(
    public player: PlayerLogic,
    protected cartService: CartService
  ) {
    super(player, cartService)
  }

  ngOnInit(): void {}

  playTrack(e: MouseEvent, track: ITrack) {
    // checks necessary to show the active track
    if (this.player.currentTrack?.id === track.id && this.player.currentTrack !== null) {
      this.onPlayPauseClick(e)
    } else {
      this.play(e, track)

      // TODO (excessive playlist setting): Remove commented setting of playlist if no bugs are found
      // this.player.setPlayList(this.tracks.map(convertITrackToPlayerTrack))
    }
  }
}
